class DeviceColorSwitcher {
  constructor() {
    this.colorButtons = document.querySelectorAll(".device-color__item");
    this.init();
  }

  init() {
    this.colorButtons.forEach(button => {
      button.addEventListener("click", (e) => {
        this.handleColorClick(e.currentTarget);
      });
    });
  }


  handleColorClick(button) {
  // Remove active from all
    this.colorButtons.forEach(btn => {
        btn.classList.remove("active");
    });

    // Add active to clicked
    button.classList.add("active");

    const colorName = button
        .querySelector(".visually-hidden")
        .textContent.trim();

    const newColor = colorName + "17";

    this.updateMainGallery(newColor);
    this.updateFirstThumbnail(newColor);
    this.goToFirstSlide();

    console.log("Updated to:", newColor);
    }


  /* ===============================
    GO TO FIRST SLIDE ⭐ NEW
  =============================== */

  goToFirstSlide() {
    const firstThumb = document.querySelector(
      '.slideshow-controls__thumbnails button:not(.hidden)'
    );

    if (firstThumb) {
      firstThumb.click();
    }
  }
  /* ===============================
     UPDATE FIRST MAIN IMAGE
  =============================== */
  updateMainGallery(newColor) {

  const media = document.querySelector(
    "slideshow-slide .product-media"
  );

  if (!media) return;

  const img = media.querySelector("img");
  if (!img) return;

  const updatedSrc = img.src.replace(
    /_(.*?)17/,
    `_${newColor}`
  );

  img.src = updatedSrc;

  if (img.srcset) {
    img.srcset = img.srcset.replace(
      /_(.*?)17/g,
      `_${newColor}`
    );
  }

}


  /* ===============================
     UPDATE ONLY FIRST THUMBNAIL
  =============================== */
  updateFirstThumbnail(newColor) {
    const firstThumb = document.querySelector(
      ".slideshow-controls__thumbnail img"
    );

    if (!firstThumb) return;

    const updatedSrc = firstThumb.src.replace(
      /_(.*?)17/,
      `_${newColor}`
    );

    firstThumb.src = updatedSrc;

    if (firstThumb.srcset) {
      firstThumb.srcset = firstThumb.srcset.replace(
        /_(.*?)17/g,
        `_${newColor}`
      );
    }
  }
}

// Run it
new DeviceColorSwitcher();


// cart upsell slider
// 
function initUpsellCustomSlider() {

  const slider = document.querySelector('.upsell-slider');
  if (!slider) return;

  const track = slider.querySelector('.upsell-track');
  const slides = slider.querySelectorAll('.upsell-card');
  const dotsWrap = slider.querySelector('.upsell-dots');

  if (!track || slides.length === 0 || !dotsWrap) return;

  let index = 0;
  let startX = 0;
  let isDragging = false;

  // 🔥 RESET STATE (important on re-init)
  track.style.transform = 'translateX(0)';
  dotsWrap.innerHTML = '';

  // ✅ 👉 SINGLE SLIDE FIX
  if (slides.length <= 1) {
    dotsWrap.style.display = 'none';
    track.style.transform = 'none';

    // ❌ remove drag events
    track.onmousedown = null;
    track.onmouseup = null;
    track.onmouseleave = null;
    track.ontouchstart = null;
    track.ontouchend = null;

    return;
  }

  // ✅ show dots if multiple
  dotsWrap.style.display = 'flex';

  // 🔥 CREATE DOTS
  slides.forEach((_, i) => {
    const dot = document.createElement('button');
    dot.className = 'upsell-dot';
    if (i === 0) dot.classList.add('active');

    dot.addEventListener('click', () => {
      index = i;
      updateSlider();
    });

    dotsWrap.appendChild(dot);
  });

  function updateSlider() {
    track.style.transform = `translateX(-${index * 100}%)`;

    dotsWrap.querySelectorAll('.upsell-dot').forEach((d, i) => {
      d.classList.toggle('active', i === index);
    });
  }

  // 🔥 DRAG (clean override every init)
  track.onmousedown = (e) => {
    isDragging = true;
    startX = e.pageX;
  };

  track.onmouseup = (e) => {
    if (!isDragging) return;

    let diff = e.pageX - startX;

    if (diff > 50 && index > 0) index--;
    if (diff < -50 && index < slides.length - 1) index++;

    updateSlider();
    isDragging = false;
  };

  track.onmouseleave = () => isDragging = false;

  // 🔥 TOUCH
  track.ontouchstart = (e) => {
    startX = e.touches[0].clientX;
  };

  track.ontouchend = (e) => {
    let diff = e.changedTouches[0].clientX - startX;

    if (diff > 50 && index > 0) index--;
    if (diff < -50 && index < slides.length - 1) index++;

    updateSlider();
  };
}




// 🔥 First load (fallback)
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(initUpsellCustomSlider, 500);
});

// 🔥 Shopify cart drawer update
document.addEventListener('cart:update', function () {
  setTimeout(initUpsellCustomSlider, 300);
});

// 🔥 EXTRA SAFETY (when section re-renders silently)
document.addEventListener('shopify:section:load', function () {
  setTimeout(initUpsellCustomSlider, 300);
});
/* VARIANT CHANGE */
document.addEventListener('change', function(e){
  if(e.target.classList.contains('upsell-variant-select')){
    const select = e.target;
    const card = select.closest('.upsell-card');
    const price = select.selectedOptions[0].dataset.price;
    card.querySelector('.upsell-price').innerText = price;
  }
});

/* ADD TO CART */
document.addEventListener('click', function(e){

  const btn = e.target.closest('.upsell-btn');
  if(!btn) return;

  const card = btn.closest('.upsell-card');
  const variantId = card.querySelector('.upsell-variant-select').value;

  btn.disabled = true;
  btn.innerText = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(res => res.json())
  .then(() => {
    btn.innerText = '✓ Added';
    refreshCartDrawer();
  })
  .catch(() => {
    btn.disabled = false;
    btn.innerText = 'Add';
  });

});



function refreshCartDrawer() {
  fetch('/?sections=cart-drawer')
    .then(res => res.json())
    .then(data => {
      document.dispatchEvent(new CustomEvent('cart:update', {
        detail: { data: { sections: data } }
      }));
      initUpsellCustomSlider();
    });
}